import { apiFunction } from "../../apiCalls/function";
import * as APIs from "../../apiCalls/urls/admin/vcReport";


export const getSchoolVcreport = async (date) => {
    return await apiFunction(`${APIs.GET_SCHOOL_VC_REPORT}?date=${date}%`, "get", null, true, "admin")
}